import { all, takeLatest, put, select, call } from 'redux-saga/effects';

import cookie from '@snapask/common-components/dist/utils/cookie';

import { fetchCampaign } from '@blueberry/services/apis';
import { appendCampaignResult } from '@blueberry/services/local';

import {
  types,
  fetchCampaignFailure,
  fetchCampaignSuccess,
  getQuizzes,
  fetchCampaignResultSuccess,
  fetchCampaignResultFailure,
  getAnswers,
  getCampaign,
} from '@blueberry/redux/campaign';
import { actions as errorActions } from '@blueberry/redux/error';
import { getUserID } from '@blueberry/redux/profile';
import {
  CAMPAIGN_ANSWERS,
  CAMPAIGN_RESULT_SAVED,
} from '@blueberry/constants/cookieNames';

import config from '@blueberry/config';

export function* fetchCampaignFlow(action) {
  try {
    const { id } = action.payload;

    const campaign = yield call(fetchCampaign, id);
    const quizzes = campaign.quizzes || [];

    delete campaign.quizzes;

    yield put(fetchCampaignSuccess(campaign, quizzes));
  } catch (err) {
    yield put(fetchCampaignFailure());
  }
}

export function* fetchCampaignResultFlow(action) {
  yield call(fetchCampaignFlow, action);

  try {
    const quizzes = yield select(getQuizzes);
    const answers = yield select(getAnswers);
    let correctCount = 0;
    quizzes.forEach((quiz, index) => {
      const answer = answers[index];
      if (answer === quiz.correct_ans) {
        correctCount++;
      }
    });

    // A: 100~90  -> 0
    // B: 90~75   -> 1
    // C: 75~60   -> 2
    // D: 60~0    -> 3

    let score = 3;
    const percentage = (correctCount / quizzes.length) * 100;

    if (percentage >= 90) {
      score = 0;
    } else if (percentage >= 75) {
      score = 1;
    } else if (percentage >= 60) {
      score = 2;
    }
    yield put(fetchCampaignResultSuccess(score));
  } catch (err) {
    yield put(fetchCampaignResultFailure());
    yield put(errorActions.sendError(err));
  }
}
export function* saveCampaignResultFlow() {
  const answers = yield select(getAnswers);
  const quizzes = yield select(getQuizzes);
  const campaign = yield select(getCampaign);
  const userId = yield select(getUserID);
  try {
    const snapCookie = new cookie(config.COOKIE_DOMAIN);
    const campaignSaved = snapCookie.readCookie(CAMPAIGN_RESULT_SAVED);
    if (campaignSaved) return;

    const campaignResultToSaved = quizzes.map(
      ({ qz_id, correct_ans }, index) => ({
        campaignName: campaign.name,
        qzId: qz_id,
        order: index,
        correctAns: correct_ans,
        answer: answers[index],
        userId,
      })
    );
    yield put(appendCampaignResult(campaignResultToSaved));
    snapCookie.setCookie(CAMPAIGN_RESULT_SAVED, true);
  } catch (err) {
    yield put(errorActions.sendError(err));
  }
}

export function* saveResultFlow() {
  const answers = yield select(getAnswers);

  const snapCookie = new cookie(config.COOKIE_DOMAIN);
  snapCookie.setCookie(CAMPAIGN_ANSWERS, JSON.stringify(answers));
}

export default function*() {
  yield all([
    takeLatest(types.FETCH_CAMPAIGN, fetchCampaignFlow),
    takeLatest(types.FETCH_CAMPAIGN_RESULT, fetchCampaignResultFlow),
    takeLatest(types.SAVE_RESULT, saveResultFlow),
    takeLatest(types.SAVE_CAMPAIGN_RESULT, saveCampaignResultFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/campaign.js